"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./_internal/utils");
function tap(f, v) {
    if (v === undefined) {
        return function (v) { return tap(f, v); };
    }
    var res = (0, utils_1.isPromise)(v) ? v.then(f) : f(v);
    if ((0, utils_1.isPromise)(res)) {
        return res.then(function () { return v; });
    }
    return v;
}
exports.default = tap;
//# sourceMappingURL=tap.js.map